import { ActionCreatorWithPayload, ActionCreatorWithPreparedPayload, ListenerEffectAPI } from '@reduxjs/toolkit';
import { listenerMiddleware, RootState, store } from '.';
import { appContextSlice } from './features/context/slice';
import { addFileAction } from './features/files/actions';
import { AppSteps } from '../api/api.type';
import { createNewFiles } from './features/newFiles/actions';
import { pagesSlice } from './features/pages/pagesSlice';
import isObject from 'lodash/isObject';
import isNil from 'lodash/isNil';
import isArray from 'lodash/isArray';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';

export const AppInsightsAsync = (async () => {
    try {
        const configResponse = await fetch('/ai.json');
        if (configResponse.status === 200) {
            const configJson: { instrumentationKey: string } = await configResponse.json();
            if (configJson.instrumentationKey) {
                const appInsights = new ApplicationInsights({
                    config: {
                        instrumentationKey: configJson.instrumentationKey,
                        enableUnhandledPromiseRejectionTracking: true,
                        disableFlushOnBeforeUnload: false
                    }
                });

                appInsights.loadAppInsights();
                appInsights.context.session.id = store.getState().context.sessionId;
                appInsights.trackPageView();

                const logger = async (type: string, payload: any) => {
                    console.log(`Action ${type}`, isObject(payload) ? payload : { payload });
                    const properties = isNil(payload)
                        ? [null]
                        : isArray(payload)
                          ? payload
                          : isObject(payload)
                            ? [payload]
                            : [{ payload }];

                    for (const prop of properties) {
                        appInsights.trackEvent({
                            name: type,
                            properties: prop
                        });
                    }
                };

                const logAction = <T>(
                    action: ActionCreatorWithPayload<T> | ActionCreatorWithPreparedPayload<any, T>,
                    map?: (payload: T, api: ListenerEffectAPI<RootState, any>) => any
                ) => {
                    listenerMiddleware.startListening({
                        actionCreator: action,
                        effect: async (action, api) =>
                            await logger(
                                action.type,
                                map ? map(action.payload, api as ListenerEffectAPI<RootState, any>) : action.payload
                            )
                    });
                };

                logAction(appContextSlice.actions.toggleDividedEachPageAction);
                logAction(appContextSlice.actions.resetDividedEachPageAction);
                logAction(appContextSlice.actions.addErrors);
                logAction(appContextSlice.actions.clearErrors);
                logAction(appContextSlice.actions.setAppStepAction, payload => AppSteps[payload]);
                logAction(addFileAction, payload => ({
                    ...payload.file,
                    pages: payload.pages
                }));

                logAction(pagesSlice.actions.hide);
                logAction(pagesSlice.actions.insert);
                logAction(pagesSlice.actions.mergeAll);
                logAction(pagesSlice.actions.restore);
                logAction(pagesSlice.actions.setUserFilename);
                logAction(pagesSlice.actions.show);
                logAction(pagesSlice.actions.split);
                logAction(pagesSlice.actions.splitAll);

                logAction(createNewFiles.fulfilled);

                return appInsights;
            }
        }
    } catch {
        /* empty */
    }
    return null;
})();
